import request from './request';

const directions = {
	async getDirections(query) {
		const response = await request.get('/app/directions', query);
		return response;
	},
	async getLocations(query) {
		const response = await request.get('/app/directions/search', query);
		return response;
	},
	async getNearest(query) {
		const response = await request.get('/app/directions/nearest', query);
		return response;
	}
};

export default directions;